import { useEffect, useRef } from 'react'
import { fitCanvas, isLightTheme, themeColor } from './card-fx'
import { GLOW_DRAWS } from './card-glow-draw'
import type { GlowState } from './card-glow-draw'
import styles from './card-glow.module.css'

const CSS_LAYERS: readonly (readonly string[])[] = [
  ['breathe'],
  [],
  [],
  ['aurora a1', 'aurora a2', 'aurora a3'],
  [],
  ['breathe slow'],
  ['halo'],
  ['aurora warm a1', 'aurora warm a2', 'aurora warm a3'],
  [],
  ['halo'],
  ['breathe'],
]

function cls(names: string): string {
  return names
    .split(' ')
    .map((n) => styles[n] ?? '')
    .join(' ')
}

type Props = {
  variant: number
  width: number
  backdrop?: boolean
}

export function CardGlow({ variant, width, backdrop = true }: Props) {
  const backRef = useRef<HTMLCanvasElement>(null)
  const frontRef = useRef<HTMLCanvasElement>(null)
  const draw = GLOW_DRAWS[variant] ?? null

  useEffect(() => {
    if (!draw) return
    const st: GlowState = { motes: [], points: null, lastPhase: 1 }
    const k = width / 160
    let frame = 0
    const tick = (now: number) => {
      const back = backRef.current && fitCanvas(backRef.current)
      const front = frontRef.current && fitCanvas(frontRef.current)
      if (back && front) {
        const light = isLightTheme()
        const c = light ? { gold: '#e0a43c', soft: '#c98a2a' } : { gold: themeColor('--accent', '#e8b04a'), soft: themeColor('--accent-soft', '#f6d98f') }
        draw({ back: back[0], front: front[0], w: back[1], h: back[2], t: now / 1000, c, k, st })
      }
      frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [draw, width])

  return (
    <>
      {(backdrop ? (CSS_LAYERS[variant] ?? []) : []).map((names) => (
        <div key={names} className={`${styles.layer} ${cls(names)}`} aria-hidden="true" />
      ))}
      {draw && <canvas ref={backRef} className={`${styles.canvas} ${styles.back}`} aria-hidden="true" />}
      {draw && <canvas ref={frontRef} className={`${styles.canvas} ${styles.front}`} aria-hidden="true" />}
    </>
  )
}
